import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { useAuth } from "@/context/AuthContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// Rende dinamicamente un insieme di campi contestuali.
// schema: [{key,label,type,options?}], values: object, onChange(key,value)
export function DynamicFields({ schema, values, onChange, cars = [], idPrefix = "f" }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {schema.map((field) => {
        const v = values?.[field.key] ?? "";
        const tid = `${idPrefix}-${field.key}`;
        const isWide = field.type === "textarea";
        return (
          <div key={field.key} className={isWide ? "sm:col-span-2 space-y-1.5" : "space-y-1.5"}>
            {field.type !== "checkbox" && (
              <Label className="text-xs font-medium text-slate-600">{field.label}</Label>
            )}
            {field.type === "textarea" && (
              <Textarea
                data-testid={tid}
                value={v}
                onChange={(e) => onChange(field.key, e.target.value)}
                rows={2}
              />
            )}
            {(field.type === "text" || field.type === "number" || field.type === "date" || field.type === "time") && (
              <Input
                data-testid={tid}
                type={field.type === "number" ? "number" : field.type}
                value={v}
                onChange={(e) => onChange(field.key, field.type === "number" ? e.target.value : e.target.value)}
              />
            )}
            {field.type === "checkbox" && (
              <label className="flex items-center gap-2 cursor-pointer pt-5">
                <Checkbox
                  data-testid={tid}
                  checked={!!v}
                  onCheckedChange={(c) => onChange(field.key, !!c)}
                />
                <span className="text-sm text-slate-700">{field.label}</span>
              </label>
            )}
            {field.type === "car-select" && (
              <Select value={v || undefined} onValueChange={(val) => onChange(field.key, val)}>
                <SelectTrigger data-testid={tid}><SelectValue placeholder="Seleziona auto" /></SelectTrigger>
                <SelectContent>
                  {cars.map((c) => (
                    <SelectItem key={c.id} value={c.modello}>
                      {c.modello} — {c.targa} {c.disponibile ? "" : "(non disp.)"}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            )}
            {field.type === "select" && (
              <Select value={v || undefined} onValueChange={(val) => onChange(field.key, val)}>
                <SelectTrigger data-testid={tid}><SelectValue placeholder="Seleziona" /></SelectTrigger>
                <SelectContent>
                  {field.options.map((o) => (
                    <SelectItem key={o} value={o}>{o}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            )}
          </div>
        );
      })}
    </div>
  );
}
